import { createProposal } from '../../components/MultipleDocuments/requests';
import { buildWebDataForTemplate } from '../parser/buildWebDataForProposal';
import { KIND_STANDALONE, PROPOSAL_KIND_WEBSITE } from '../utils/webTemplateKind';
import { fetchWebTemplatesForDocument } from './webTemplates';
import { saveWebData } from './webProposal';

/**
 * Site web seul : un proposal sans contenu classique, semé depuis un modèle
 * « Site web seul » (cf. docs/webviewer/chantier-templates-autonomes.md).
 */

/** Modèles « Site web seul » qui conviennent au document : son type, et son métier. */
export function fetchStandaloneTemplates(documentIdentity) {
  return fetchWebTemplatesForDocument(documentIdentity, KIND_STANDALONE);
}

/**
 * Crée le site puis écrit son `web_data`, déjà résolu sur le document.
 *
 * @returns {Promise<object|null>} le proposal créé, `null` si la création a échoué
 */
export async function createStandaloneWebsite({ documentIdentity, name, templateId }) {
  const created = await createProposal(
    documentIdentity.id,
    { name, kind: PROPOSAL_KIND_WEBSITE, web_template_id: templateId },
    documentIdentity.type,
  );
  if (!created) return null;

  const webData = await buildWebDataForTemplate({ templateId, documentIdentity });
  // Proposal neuf : jeton de version à 0.
  await saveWebData(created.id, webData, 0);
  return created;
}
